import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    const seedSubtotal = parseFloat(this.element.dataset.orderSeedSubtotal)
    const email = this.element.dataset.orderEmail

    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'SubmitOrder',
        'conversionValue': seedSubtotal
      })
      window.dataLayer.push({
        'set': 'user_data',
        'sha256_email_address': email
      })
    }
    // if (window.gtag) {
    //   window.gtag('set', 'user_data', { "sha256_email_address": email })
    //   window.gtag('event', 'SubmitOrder', { event_category: 'Purchase', currency: 'USD', value: seedSubtotal })
    //   window.gtag('event', 'conversion', {'send_to': 'AW-779913037/QlWVCIT85YcYEM2O8vMC', 'value': seedSubtotal, 'currency': 'USD'})
    // }
    // if (window.fbq) {
    //   window.fbq('track', 'Purchase', { currency: 'USD', value: seedSubtotal })
    // }
    // if (window.uetq) {
    //   window.uetq.push('event', 'purchase', {"revenue_value":seedSubtotal, "currency":"USD"})
    // }
  }

}